module.exports = __webpack_public_path__ + "static/media/12A.9f2667d2.png";